import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import {
  selectNavigationStyleIsLoading,
  selectNavigationStyleIsSubmitting,
} from 'api/navigationStyle'
import {
  selectNavigationTabsIsLoading,
  selectNavigationTabsIsSubmitting,
} from 'api/navigationTabs'
import bottomPlacementPreview from 'assets/images/cms/app-navigation/homepage-bottomnav-preview-bottom.svg'
import topPlacementPreview from 'assets/images/cms/app-navigation/homepage-bottomnav-preview-top.svg'
import { buildTranslate } from 'locales'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showConfirmModal } from 'slices/Cms/Content/AppNavigation'
import { selectBottomNavHasChanges } from 'slices/Cms/Content/AppNavigation/BottomNav/selectors'
import { selectStyleHasChanges } from 'slices/Cms/Content/AppNavigation/Style/selectors'

const t = buildTranslate('cms.content.app_navigation')

const Sidebar: React.FC = () => {
  const [css] = useStyletron()
  const dispatch = useDispatch()

  // Get loading states using clean selectors (no parameters needed!)
  const isStyleLoading = useSelector(selectNavigationStyleIsLoading)
  const isTabsLoading = useSelector(selectNavigationTabsIsLoading)
  const isStyleSubmitting = useSelector(selectNavigationStyleIsSubmitting)
  const isTabsSubmitting = useSelector(selectNavigationTabsIsSubmitting)

  // Combine loading states
  const isLoading = isStyleLoading || isTabsLoading
  const isFormSubmitting = isStyleSubmitting || isTabsSubmitting

  const hasStyleChanges = useSelector(selectStyleHasChanges)
  const hasBottomNavChanges = useSelector(selectBottomNavHasChanges)

  const confirmSubmit = () => {
    dispatch(showConfirmModal())
  }

  return (
    <>
      <Button
        className={`mb-l px-s ${css({ width: '200px' })}`}
        isLoading={isLoading || isFormSubmitting}
        disabled={!hasStyleChanges && !hasBottomNavChanges}
        onClick={confirmSubmit}
        type="button"
      >
        {t('sidebar.publish')}
      </Button>
      <div className="mb-l">
        <Text.BodyText4 className="mb-xs font-size-14" bold>
          {t('sidebar.top_placement_preview')}
        </Text.BodyText4>
        <img
          className={`mb-md ${css({
            width: '200px',
          })}`}
          src={topPlacementPreview}
          alt={t('sidebar.preview')}
        />
      </div>
      <div className="mb-l">
        <Text.BodyText4 className="mb-xs font-size-14" bold>
          {t('sidebar.bottom_placement_preview')}
        </Text.BodyText4>
        <img
          className={`mb-md ${css({
            width: '200px',
          })}`}
          src={bottomPlacementPreview}
          alt={t('sidebar.preview')}
        />
      </div>
    </>
  )
}

export default Sidebar
